// extracted by mini-css-extract-plugin
export var activityContainer = "_gk-0";
export var typingIndicatorContainer = "_gk-1";
export var typingIndicatorDot = "_gk-2";
export var wave = "_gk-3";